<div class="logo">
  <a href="#" class="simple-text logo-mini">
    <div class="logo-img">
      <img src="assets/img/favicon/{{siteName}}.ico" />
    </div>
  </a>
  <a href="#" class="simple-text logo-normal">
    DashBoard
  </a>
</div>
<div class="sidebar-wrapper">
  <ul class="nav">
    <!-- <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{ menuItem.class }} nav-item">
      <a [routerLink]="[menuItem.path]">
        <i class="tim-icons  {{ menuItem.icon }}"></i>
        <p>{{ menuItem.title }}</p>
      </a>
    </li> -->

    <li *ngFor="let menuItem of FilterlevelHierarchy" class="{{ menuItem.class }} nav-item">
      <a [routerLink]="[menuItem.path]">
        <i class="tim-icons  {{ menuItem.icon }}"></i>
        <p>{{ menuItem.name }}</p>
      </a>
    </li>

    <li class="nav-item">
      <a routerLink="proxy-list">
        <i class="tim-icons icon-single-02"></i>
        <p>Proxy Link</p>
      </a>
    </li>
    <!-- QUIZ DROPDOWN -->
    <li class="nav-item" *ngIf="siteName == 'play25'">
      <a href="javascript:void(0)" (click)="toggleDropdown('quiz')">
        <i class="tim-icons icon-single-02"></i>
        <p>
          Quiz
          <span class="caret" [ngClass]="{ 'rotate': isQuizOpen }"></span>
        </p>
      </a>

      <ul style="margin-top: 0;" *ngIf="isQuizOpen" class="nav sub-menu">
        <li class="nav-item">
          <a routerLink="create-quiz">
            <p>Create Quiz</p>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="quiz-report">
            <p>Quiz Report</p>
          </a>
        </li>
      </ul>
    </li>

    <!-- LOTTERY DROPDOWN -->
    <li class="nav-item" *ngIf="siteName == 'play25'">
      <a href="javascript:void(0)" (click)="toggleDropdown('lottery')">
        <i class="tim-icons icon-single-02"></i>
        <p>
          Lottery
          <span class="caret" [ngClass]="{ 'rotate': isLotteryOpen }"></span>
        </p>
      </a>

      <ul style="margin-top: 0;" *ngIf="isLotteryOpen" class="nav sub-menu">
        <li class="nav-item">
          <a routerLink="lottery">
            <p>Lottery User Infos</p>
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="lottery-old">
            <p>Old Lottery User Infos</p>
          </a>
        </li>
      </ul>
    </li>
    <li class="nav-item">
      <a routerLink="latest-updates">
        <i class="tim-icons icon-single-02"></i>
        <p>Latest Updates</p>
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="fb-link">
        <i class="fa-brands fa-facebook-f"></i>
        <p>FaceBook </p>
      </a>
    </li>



  </ul>
</div>
